/* eslint-disable no-unused-expressions */
/* eslint-disable consistent-return */
import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@techsoftware/happay-widgets/Grid';
import { Icons, Button } from '@techsoftware/happay-widgets';
import GuideLinesDialog from './guideLinesDialog';
import Locales from '../../constants/locales';
import KYCPENDING from '../../assets/images/pending-kyc.svg';
import KYCSUCCESS from '../../assets/images/kyc-success.svg';
import KYCNOTINITIATED from '../../assets/images/kyc-not-initiated.svg';
import KYCDECLINED from '../../assets/images/kyc-declined.svg';

const constants = Locales.JSON.kyc;

class KYC extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openGuideLinesDialog: false,
    };
  }

  getKycStatus() {
    const kycStatus = {
      title: '',
      subText: '',
      backgroundClass: '',
      image: null,
    };
    const { userInfo } = this.props;
    switch (userInfo.kyc_status) {
      case 0:
        kycStatus.title = 'KYC complete !';
        kycStatus.kycDoc = '';
        kycStatus.backgroundClass = 'kyc-approved';
        kycStatus.image = KYCSUCCESS;
        break;
      case 1:
        kycStatus.title = 'Complete KYC pending verification !';
        kycStatus.kycDoc = '';
        kycStatus.backgroundClass = 'kyc-pending';
        kycStatus.kycVideo =
          'Get into a video call with KYC expert and get your documents and KYC verified in no time.';
        kycStatus.image = KYCPENDING;
        break;
      case 4:
        kycStatus.title = 'Limited KYC';
        kycStatus.kycDoc = '';
        kycStatus.backgroundClass = 'kyc-pending';
        kycStatus.kycVideo =
          'Get into a video call with KYC expert and get your documents and KYC verified in no time.';
        kycStatus.image = KYCPENDING;
        break;
      case 2:
        kycStatus.title =
          'Have the documents handy now?  Click on complete KYC options below.';
        kycStatus.kycDoc =
          'Upload correct documents and enjoy all the benefits of our products KYC verification might take 2 to 3 working days.';
        kycStatus.kycVideo =
          'Get into a video call with KYC expert and get your documents and KYC verified in no time.';
        kycStatus.backgroundClass = 'kyc-declined';
        kycStatus.image = KYCDECLINED;
        break;
      case 3:
        kycStatus.title =
          'Have the documents handy now?  Click on complete KYC options below.';
        kycStatus.kycDoc =
          'Upload correct documents and enjoy all the benefits of our products KYC verification might take 2 to 3 working days.';
        kycStatus.kycVideo =
          'Get into a video call with KYC expert and get your documents and KYC verified in no time.';
        kycStatus.backgroundClass = 'kyc-not-initiated';
        kycStatus.image = KYCNOTINITIATED;
        break;
      default:
        break;
    }
    return kycStatus;
  }

  toggleGuideline = () => {
    const { openGuideLinesDialog } = this.state;
    this.setState({
      openGuideLinesDialog: !openGuideLinesDialog,
    });
  };

  render() {
    const { userInfo } = this.props;
    // if (userInfo) {
    //   userInfo.kyc_status = 4;
    // }

    const { openGuideLinesDialog } = this.state;
    const checkKycStatus = this.getKycStatus();
    return (
      <Grid item xs={24}>
        <Grid container className="bordered-container margin-b-20 padding-30">
          <Grid xs={24} container className="margin-b-10">
            <div className="body dark fw-500">{constants.FULL_KYC}</div>
          </Grid>
          <div className="info-text regular margin-b-20">
            {constants.KYC_MSG}
          </div>
          {userInfo.kyc_reason && userInfo.kyc_status === 2 ? (
            <Grid container direction="row" className="margin-b-20">
              <Grid item className="decline-kyc">
                <Icons className="alert-red-color" type="error" size="large" />
              </Grid>
              <Grid item className="kyc-reason margin-b-30 padding-l-20">
                <div className="alert-message failure">Decline reason</div>
                <div className="body fw-500">{userInfo.kyc_reason}</div>
              </Grid>
            </Grid>
          ) : null}
          {userInfo.kyc_status === 3 && (
            <>
              <div className="fw-700 body">{constants.KYC_TIPS.DESC}</div>
              <div className="body margin-tb-12 full-width">
                <div className="inline-block">
                  <div>
                    <span className="font-14 fw-600">
                      {constants.KYC_TIPS.PHOTO}
                    </span>
                    {` : ${constants.KYC_TIPS.PHOTO_DESC}`}
                  </div>
                  <div>
                    <span className="font-14 fw-600">
                      {constants.KYC_TIPS.IDENTITY_PROOF}
                    </span>
                    {` :  ${constants.KYC_TIPS.IDENTITY_PROOF_DESC}`}
                  </div>
                  <div>
                    <span className="font-14 fw-600">
                      {constants.KYC_TIPS.ADDRESS_PROOF}
                    </span>
                    {` : ${constants.KYC_TIPS.ADDRESS_PROOF_DESC}`}
                  </div>
                </div>
                <Button
                  variant="secondary"
                  startIcon="document"
                  text={constants.KYC_TIPS.BTN_DESC}
                  className="float-right kyc-prepare-document-btn"
                  onClick={this.toggleGuideline}
                />
              </div>
              {openGuideLinesDialog && (
                <GuideLinesDialog
                  {...this.props}
                  closeGuideLinesDialog={this.toggleGuideline}
                />
              )}
            </>
          )}
          <Grid
            xs={24}
            sm={24}
            md={24}
            lg={24}
            xl={18}
            container
            alignItems="center"
            className={`padding-20 ${checkKycStatus.backgroundClass}`}
          >
            <Grid container item xs={24} justify="flex-start">
              <Grid item xs={16} container alignItems="center">
                <span>
                  <img src={checkKycStatus.image} alt="" />
                </span>
                <span className="margin-l-10">{checkKycStatus.title}</span>
              </Grid>
              <Grid container item xs={8} justify="flex-end">
                {!checkKycStatus.kycDoc ? (
                  <Button
                    onClick={() => {
                      this.props.getVideoKycLink();
                    }}
                    type="button"
                    variant="primary"
                    text="Full KYC"
                  />
                ) : null}
              </Grid>
            </Grid>
            {checkKycStatus.kycDoc ? (
              <Grid container item xs={24} justify="flex-start">
                <Grid item xs={16}>
                  <div className=" padding-l-40 info-text regular">
                    {checkKycStatus.kycDoc}
                  </div>
                </Grid>
                <Grid container item xs={8} justify="flex-end">
                  <Button
                    onClick={() => {
                      this.props.getVideoKycLink();
                    }}
                    type="button"
                    variant="primary"
                    text="Full KYC"
                  />
                </Grid>
              </Grid>
            ) : null}
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

KYC.propTypes = {
  userInfo: PropTypes.object,
  getVideoKycLink: PropTypes.func,
};

export default KYC;
